module.exports = __webpack_public_path__ + "static/media/kpi_available.aed2c3be.svg";